import { render, staticRenderFns } from "./PedidosDetalleOverview.vue?vue&type=template&id=5ad39bb0&"
import script from "./PedidosDetalleOverview.vue?vue&type=script&lang=js&"
export * from "./PedidosDetalleOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports